<template>
  <div style="overflow: hidden">
    <div
      v-if="userWithSameEmail"
      class="h-screen w-full flex justify-center items-center"
    >
      <div
        style="width: 540px; height: 392px; padding-right: 3rem"
        class="relative bg-white pt-12 pl-12 border border-gray-200 shadow-sm"
      >
        <p class="text-3xl leading-9 font-semibold mb-4 text-gray-900">
          Looks like you have an existing account
        </p>
        <p class="text-gray-600 font-normal text-base">
          To link accounts, enter your current password in the field below to
          create a new organization account.
        </p>
        <input
          name="current_password"
          placeholder="Current password"
          type="password"
          v-model="form.existing_password"
          class="shadow-sm mt-4 mr-12 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
        />
        <input
          class="btn button signup-submit"
          type="button"
          @click="submit"
          :value="submitButtonText"
          tabindex="4"
          :disabled="disableButton"
          data-disable-with="Log in"
        />
        <a
          href="/auth/password/new"
          class="mt-4 block text-base font-normal text-gray-600 underline"
        >
          Forgot your password?
        </a>
        <img
          id="cat-login"
          class="absolute"
          style="top: -45%; right: -15%; z-index: -1"
          :src="require(`images/reactivate_kitty.png`)"
        />
      </div>
    </div>
    <div
      :class="userWithSameEmail ? 'hidden' : ''"
      class="flex flex-col md:flex-row my-0 min-h-screen bg-white"
    >
      <div class="w-full md:w-1/2 flex items-center justify-center">
        <div class="signup-main w-full">
          <div class="signup-form-wrapper">
            <div class="form-container-signup smaller-form flex flex-col">
              <div class="subdomain-logo self-center" style="width: 70%">
                <Logo type="LONG" class="signup-logo w-full" />
              </div>
              <div
                class="w-4 h-0.5 flex-shrink-0 bg-coach-green-500 my-4 self-center"
              ></div>
              <p class="signup-p self-center" v-if="urlParam || superOrg">
                Create Your Account
              </p>
              <div v-else>
                <p class="signup-p self-center">
                  Start Your {{ trialDays }}-Day Trial
                </p>
              </div>

              <div>
                <form
                  novalidate="novalidate"
                  class="simple_form new_user mt-4"
                  id="new_user"
                  accept-charset="UTF-8"
                  method="post"
                >
                  <input name="utf8" type="hidden" value="✓" />
                  <fieldset>
                    <div v-if="!isLoginDetailsInParams" class="d-flex">
                      <div class="input optional">
                        <label class="signup-label">First Name</label>
                        <input
                          tabindex="1"
                          autofocus="autofocus"
                          class="string optional"
                          type="text"
                          v-model="form.first_name"
                          placeholder="John"
                        />
                      </div>

                      <div class="input ml-4">
                        <label class="signup-label">Last Name</label>
                        <input
                          tabindex="2"
                          class="string optional"
                          type="text"
                          v-model="form.last_name"
                          placeholder="Doe"
                        />
                      </div>
                    </div>

                    <div
                      v-if="!isLoginDetailsInParams"
                      class="input email user_email"
                    >
                      <label class="signup-label">Email</label>
                      <input
                        tabindex="3"
                        autofocus="autofocus"
                        class="string email"
                        type="email"
                        v-model="form.email"
                        placeholder="john@example.com"
                      />
                    </div>
                    <div class="input user_password">
                      <label class="signup-label">Password</label>
                      <input
                        tabindex="4"
                        class="password optional"
                        type="password"
                        v-model="form.password"
                        placeholder="Password"
                      />
                    </div>
                    <div v-if="urlParam">
                      <label class="signup-label">Card Details</label>
                      <div class="plan-card">
                        <div ref="card"></div>
                      </div>
                    </div>
                    <div>
                      <input
                        class="btn button signup-submit"
                        type="button"
                        @click="submit"
                        :value="submitButtonText"
                        tabindex="4"
                        :disabled="disableButton"
                        data-disable-with="Log in"
                      />
                    </div>
                    <div class="signup-policy text-xs text-center">
                      <p class="signup-policy-label ml-1">
                        By joining, you agree to the
                        <a
                          href="https://coachcatalyst.com/terms-of-use"
                          class="text-coach-green-500"
                          target="_blank"
                          >terms of service</a
                        >
                        and
                        <a
                          href="https://coachcatalyst.com/privacy-policy"
                          class="text-coach-green-500"
                          target="_blank"
                          >privacy policy</a
                        >
                      </p>
                    </div>
                    <p
                      class="mt-3 text-sm text-gray-600"
                      v-if="urlParam === 'webinar75'"
                    >
                      After 3 months you will automatically be enrolled <br />
                      in the $99 / month (up to 75 clients) plan. <br />
                      you can cancel or downgrade your account at any time.
                    </p>
                    <div class="text-center">
                      <p class="text-base text-primary font-normal mt-4">
                        Already have an account?
                        <span
                          class="login-start-trail font-semibold"
                          @click="signInClick"
                        >
                          Sign In</span
                        >
                      </p>
                    </div>
                  </fieldset>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="hidden md:flex w-full md:w-1/2 h-screen items-center justify-center"
      >
        <img
          class="w-full h-full max-h-screen object-fill md:object-contain rounded-none shadow-none p-6"
          :src="require(`images/signup_image.webp`)"
          alt="Signup Image"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import ApiUrls from '../../api-url';
  import AuthenticationMixin from '../../authentication-mixin';
  import ValidationMixin from '../../validation-mixin';
  import { mapGetters, mapState } from 'vuex';
  import getters from '../../stores/login-store/getters/login-getters';
  import DottedBackground from '../../svgs/DottedBackground.vue';
  import Logo from '../../components/logos/Logo.vue';

  let style = {
    base: {
      border: '1px solid #D8D8D8',
      borderRadius: '4px',
      color: '#000',
    },
    invalid: {
      // All of the error styles go inside of here.
    },
  };
  import configService from '../../services/config-service.js';
  let stripe = Stripe(configService.getStripeConfig().publishableKey, style),
    elements = stripe.elements(),
    card = undefined;
  (elements = stripe.elements()), (card = undefined);
  export default {
    mixins: [ApiUrls, AuthenticationMixin, ValidationMixin],
    components: { DottedBackground, Logo },
    data() {
      return {
        form: {
          first_name: null,
          last_name: null,
          email: null,
          password: null,
          existing_password: null,
          organization: {
            referral: '',
            referral_text: null,
            linkmink: null,
          },
        },
        disableButton: false,
        userWithSameEmail: false,
        stripeToken: null,
        isLoginDetailsInParams: false,
      };
    },
    async created() {
      await this.$store.commit('setUrlParam', this.$route.query.url_param);
      await this.$store.commit('setAccountType', this.$route.query.accountType);
      await this.$store.commit('setSuperOrg', this.$route.query.superOrg);
      await this.$store.commit('setFbClickId', this.$route.query.fbClickId);
      await this.$store.commit('setCopyCode', this.$route.query.copyCode);
      await this.getPlan();
      try {
        const linkmink = LinkMink('pub_live_Y2uAe3gyQJBmmYcpRBxz');
        const lm_data = linkmink.getReferralData();
        if (lm_data) {
          this.form.organization.linkmink = lm_data;
        }
      } catch (err) {
        console.log(err);
      }
      if (!this.isEmptyObject(this.$route.query)) {
        this.form.first_name = this.$route.query?.firstname || '';
        this.form.last_name = this.$route.query?.lastname || '';
        this.form.email = this.$route.query?.email || '';
        if (
          this.$route.query?.email &&
          this.$route.query?.firstname &&
          this.$route.query?.email
        ) {
          this.isLoginDetailsInParams = true;
        }
      }
    },
    mounted: function () {
      if (this.urlParam) {
        this.$nextTick(() => {
          card = elements.create('card');
          card.mount(this.$refs.card);
          this.$nextTick(() => {
            card.on('change', (event) => {
              if (event.complete) {
                this.disableButton = !event.complete;
              } else if (event.empty || event.error) {
                this.disableButton = true;
              }
            });
            this.validateCard();
          });
        });
      }
    },
    beforeUnmount() {
      if (this.urlParam) card.destroy(this.$refs.card);
    },
    computed: {
      ...mapState([
        'trialAmount',
        'trialDays',
        'urlParam',
        'currentPlan',
        'accountType',
        'superOrg',
        'fbClickId',
        'copyCode',
      ]),
      ...mapGetters(['LOGIN_FORM', 'SIGN_UP_COACH_INFO']),
      submitButtonText() {
        return this.urlParam
          ? `Get Started Today for Just $${
              parseInt(this.currentPlan.amount) / 100
            }`
          : 'Sign Up';
      },
    },
    methods: {
      validateCard() {
        card.on('ready', () => {
          this.disableButton = true;
        });
      },
      signInClick() {
        this.$router.push({ name: 'SigninPage' });
      },
      async getPlan() {
        let url_param = this.urlParam;
        const response = await axios.post(this.authUrl + 'get_plan', {
          url_param,
        });
        this.$store.commit('setCurrentPlan', response.data.result);
      },
      isValid() {
        if (!this.form.first_name) {
          this.$toast.show('First name required.', this.toasted_options.error);
          return false;
        }

        if (!this.form.last_name) {
          this.$toast.show('Last name required.', this.toasted_options.error);
          return false;
        }

        if (!this.validEmail(this.form.email)) {
          this.$toast.show('Invalid email.', this.toasted_options.error);
          return false;
        }

        if (!this.validPassword(this.form.password)) {
          this.$toast.show(
            'Password must be at least 6 characters.',
            this.toasted_options.error
          );
          return false;
        }
        return true;
      },
      async submit() {
        if (this.isValid()) {
          this.disableButton = true;
          const self = this;
          grecaptcha.ready(function () {
            grecaptcha
              .execute('6LfiNc4ZAAAAAA7O27dikuMBReTDKH_QeP6sLmxn', {
                action: 'submit',
              })
              .then(
                async (token) => {
                  try {
                    try {
                      window.fpr('referral', { email: self.form.email });
                    } catch (_e) {
                      /* FirstPromoter is optional; must not fail signup after /auth succeeds */
                    }
                    self.$emit('save-user', self.form);

                    let result;
                    try {
                      result = await self.axiosInstance.post('/auth', {
                        user: self.form,
                        token: token,
                        accountType: self.accountType,
                        superOrg: self.superOrg,
                        fbClickId: self.fbClickId,
                        copyCode: self.copyCode,
                        existing_password: self.existing_password,
                      });
                    } catch (err) {
                      self.disableButton = false;
                      // login axios interceptor already toasts for HTTP error bodies
                      if (!err.response) {
                        self.$toast.show(
                          err?.message ||
                            'Sign up failed. Please try again.',
                          self.toasted_options.error
                        );
                      }
                      return;
                    }

                    if (result.data.success) {
                      if (self.userWithSameEmail) {
                        self.$store.commit(
                          'setSelectedStep',
                          getters.SIGN_UP_COACH_INFO()
                        );
                        self.userWithSameEmail = false;
                        return;
                      }

                      self.userWithSameEmail = false;

                      if (self.urlParam) {
                        document.body.style.cursor = 'wait';
                        stripe
                          .createToken(card)
                          .then(async (stripeResult) => {
                            await self.submitResponse(stripeResult.token);
                          })
                          .catch(() => {
                            document.body.style.cursor = 'default';
                            self.disableButton = false;
                            self.$toast.show(
                              'Could not verify card. Please check your card details and try again.',
                              self.toasted_options.error
                            );
                          });
                      } else {
                        self.$store.commit(
                          'setSelectedStep',
                          getters.SIGN_UP_COACH_INFO()
                        );
                      }
                      return;
                    }

                    // 200 with success: false — interceptor may have already toasted
                    self.disableButton = false;

                    if (
                      result.data.error?.includes(
                        'Please select a different email.'
                      )
                    ) {
                      self.userWithSameEmail = true;
                      return;
                    }

                    // Interceptor already toasts for most shapes; avoid duplicate "Error" toasts
                    if (
                      !result.data.error &&
                      !result.data.result &&
                      !result.data.error_message &&
                      !result.data.errors
                    ) {
                      self.$toast.show(
                        'An error occurred.',
                        self.toasted_options.error
                      );
                    }
                  } catch (e) {
                    self.disableButton = false;
                    console.error(e);
                    self.$toast.show(
                      e?.message || 'Sign up failed. Please try again.',
                      self.toasted_options.error
                    );
                  }
                },
                () => {
                  self.disableButton = false;
                  self.$toast.show(
                    'Could not verify reCAPTCHA. Please try again.',
                    self.toasted_options.error
                  );
                }
              );
          });
        } else {
          this.$store.commit(
            'setSelectedStep',
            getters.SIGN_UP_CREATE_ACCOUNT()
          );
        }
      },
      async submitResponse(token) {
        let response = await axios.post(
          this.billingUrl + 'update_billing_plan',
          {
            plan: this.currentPlan,
            token: token,
            url_param: this.urlParam,
            background: true,
          }
        );
        document.body.style.cursor = 'default';
        if (response.data.success) {
          this.$store.commit(
            'setSelectedStep',
            getters.SIGN_UP_COACH_INFO()
          );
        } else {
          this.$toast.show(response.data.result, this.toasted_options.error);
          this.disableButton = false;
        }
      },
      isEmptyObject(obj) {
        return JSON.stringify(obj) === '{}';
      },
    },
  };
</script>
